module.exports = __webpack_public_path__ + "img/pa-shop.62143b05.png";